module.exports = __webpack_public_path__ + "img/0499e6_53a2b50f961b404e8f23c0f896c4a780_mv2.aafbcf12.webp";